import * as React from "react";
import * as ReactDOM from "react-dom";
import { FaqSearch } from "../react/faq-search.jsx";
import { QuickLinks } from "../react/quick-links.jsx";
import { ArticleError } from "../react/article-error.jsx";
import { logMetadata, searchFaq } from "../common/searchFaq.js";
import { ContactOptions } from "../react/contact-options.jsx";
import {
    EgenciaProvider,
    UitkCalloutCard,
    UitkSpacing,
    UitkCalloutCardTheme,
    UitkLayoutFlex,
    UitkHeading
} from "@egencia/uitk-react";
import {CategorizedArticles} from "../react/categorized-articles";
import {LLMCard} from "../react/llm-card";
import {ChatButton} from "../react/chat-button";

EG.HelpCenter.Presenters.FullPageIndex = function (allArticles) {
    //----- Initialize -----//
    const $delegate = $('body');
    const headerContainer = ReactDOM.createRoot(document.getElementById("header-container"));
    const notificationBannerContainer = ReactDOM.createRoot(document.getElementById("banner-container"));
    const articleErrorContainer = ReactDOM.createRoot(document.getElementById("article-error"));
    const searchContainer = ReactDOM.createRoot(document.getElementById("search-container"));
    const options = ReactDOM.createRoot(document.getElementById("options"));
    const llmSearchContainer = ReactDOM.createRoot(document.getElementById("llm-search-container"));
    const faqContainer = ReactDOM.createRoot(document.getElementById("faqs-container"));
    const pageName = 'HelpCenter.HomePage';
    const pageTitle = uitk.i18n.msg('help_center_title');

    const tnePrestaCode = EG.bootstrapped.tnePrestaCode;
    
    // Set the header container
    headerContainer.render(
        <EgenciaProvider>
            <UitkSpacing margin={{blockend: "four"}}>
                <UitkHeading tag={"h1"} size={4}>{pageTitle}</UitkHeading>
            </UitkSpacing>
        </EgenciaProvider>
    );
    
    if (outageBannerEnabled()) {
        let bannerText = (EG.bootstrapped.alertMessaging.beforeOutage) ? uitk.i18n.msg('banner.message.before_maintenance') : uitk.i18n.msg('banner.message.in_maintenance');
        notificationBannerContainer.render(
            <EgenciaProvider>
                <UitkSpacing margin={{ blockend: "four" }}>
                    <div>
                        <UitkCalloutCard
                            theme={UitkCalloutCardTheme.warning}
                            headingText={bannerText}
                        />
                    </div>
                </UitkSpacing>
            </EgenciaProvider>
        );
    }
    if (EG.bootstrapped.llmFeatureToggle === false) {
        searchContainer.render(
            <EgenciaProvider>
                <FaqSearch onSearch={handleFaqSearch}/> 
            </EgenciaProvider>
        );
    }
    if (EG.bootstrapped.articleError) {
        articleErrorContainer.render(
            <EgenciaProvider>
                <UitkSpacing margin={{ blockend: "four" }}>
                    <ArticleError/>
                </UitkSpacing>
            </EgenciaProvider>);
    }
   
    // Right-hand side column
    options.render( 
        <EgenciaProvider>
            <UitkLayoutFlex direction={"column"} space={"four"}>
                {!tnePrestaCode &&
                    <QuickLinks/>
                }
                <ContactOptions/>
                <ChatButton/>
            </UitkLayoutFlex>
        </EgenciaProvider>
    );
    
    const categories = EG.bootstrapped.categoriesOrder;
    const defaultArticleGroups = [
        { title: uitk.i18n.msg('alert_section_title'), articles: EG.bootstrapped.alerts, isAlerts: true, topic: 'alerts' },
        ...categories.map((category) => {
            return {
                title: uitk.i18n.msg(category.topic),
                topic: category.topic,
                articles: EG.bootstrapped.categorizedFaqs[category.topic]
            }
        })
    ];
    renderArticleList(defaultArticleGroups);
    
    function renderArticleList(articleGroups) {
        llmSearchContainer.render(
            <EgenciaProvider>
                {EG.bootstrapped.llmFeatureToggle === true &&
                    <LLMCard/>
                }
            </EgenciaProvider>
        )
        faqContainer.render(
            <EgenciaProvider>
                <CategorizedArticles
                    articleGroups={articleGroups}
                />
            </EgenciaProvider>);
    }
    
    function outageBannerEnabled() {
        if (EG.bootstrapped && EG.bootstrapped.alertMessaging) {
            return EG.bootstrapped.alertMessaging.beforeOutage || EG.bootstrapped.alertMessaging.duringOutage;
        }
    }

    function handleFaqSearch(term) {
        if (term.length) {
            const searchResults = searchFaq.search(term, EG.bootstrapped.faqs);
            const highlightedSearchResults = searchFaq.highlightArticles(searchResults, term);
            
            const searchAlertResults = searchFaq.search(term, EG.bootstrapped.alerts);
            const highlightedAlertSearchResults = searchFaq.highlightArticles(searchAlertResults, term);
            logMetadata(searchFaq, term, searchResults.length + searchAlertResults.length);

            renderArticleList([
                { articles: highlightedAlertSearchResults, topic: 'search', isAlerts: true },
                { articles: highlightedSearchResults, topic: 'search' },
            ]);
        } else {
            renderArticleList(defaultArticleGroups);
        }
    }

    uitk.analytics.set('pageName', EG.pageName);
    uitk.analytics.send();


    // log articles
    if (EG.bootstrapped.faqIds) {
    	uitk.analytics.set('prop18', pageName + '.FAQList.Displayed.[' + EG.bootstrapped.faqIds + ']');
		uitk.analytics.set('eVar26', pageName + '.FAQList.Displayed.[' + EG.bootstrapped.faqIds + ']');
		uitk.analytics.track('o', {
			linkName: 'FAQ List Displayed',
			linkTrackVars: ',prop18,eVar26',
		});
    }
    if (EG.bootstrapped.alertIds) {
        uitk.analytics.set('prop18', pageName + '.AlertList.Displayed.[' + EG.bootstrapped.alertIds + ']');
        uitk.analytics.set('eVar26', pageName + '.AlertList.Displayed.[' + EG.bootstrapped.alertIds + ']');
        uitk.analytics.track('o', {
            linkName: 'Alert List Displayed',
            linkTrackVars: ',prop18,eVar26',
        });
    }
    
    // contact-us-links
    $delegate.on('click', '.contact-us-link', (e) => {
        e.preventDefault();
        omnitureLog.logClickEvent(`${EG.pageName}.ContactUs.Clicked`);
        uitk.helpPanel.panelOpen(`/help-center/panel/contact-options${EG.user ? '' : '/anonymous'}?override_back=true`);
    });
};